var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"contextmenu":function($event){$event.preventDefault();}}},[(_vm.layout)?_c(_vm.layout,{tag:"component"}):_vm._e(),_c('AppLoading',{ref:"loading"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }